import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

interface WrapperProps {}

export const Wrapper = styled.div<WrapperProps>`
  width: 52px;
  height: 52px;

  display: grid;
  place-items: center;

  border-radius: 30px;
  background: rgba(242, 242, 242, 0.14);
  backdrop-filter: blur(8px);

  cursor: pointer;

  ${mediaTablet(`
    width: 54px;
    height: 54px;
  `)}
`;

export const SvgContainer = styled.div`
  width: 16px;
  height: 16px;

  display: block;

  svg {
    color: ${colors.white};
  }
`;
